mutation StartStream($contentId: ID!) {
  startStream(contentId: $contentId) {
    id
    stream {
      id
      status
    }
  }
}
